var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetaDescarregamentoIndevido(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.476 0.546143H2.22603C1.50806 0.546143 0.926025 1.12817 0.926025 1.84614V15.0961C0.926025 15.8141 1.50806 16.3961 2.22603 16.3961H15.476C16.194 16.3961 16.776 15.8141 16.776 15.0961V1.84614C16.776 1.12817 16.194 0.546143 15.476 0.546143Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3186 0.546143H6.38327V8.50548L3.71436 8.50548L8.85096 14.4023L13.9876 8.50548L11.3186 8.50548V0.546143Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetaDescarregamentoIndevido);
export default __webpack_public_path__ + "static/media/seta-descarregamento-indevido.8161a86e1df147c1e63657530949afe8.svg";
export { ForwardRef as ReactComponent };